<template>
  <div class="d-flex justify-center align-center flex-column">
    <!--First block of content -->
    <div
      class="container-question"
      v-html="$t('ProductNowNow.question1')"
    ></div>
    <div
      class="mt-3 container-answer"
      v-html="$t('ProductNowNow.answer1')"
    ></div>
    <div
      class="mt-3 container-answer"
      v-html="$t('ProductNowNow.answer2')"
    ></div>

    <!-- Mission -->
    <div class="container-mission1" v-html="$t('ProductNowNow.mission1')"></div>
    <div class="container-mission2" v-html="$t('ProductNowNow.mission2')"></div>

    <!-- Answer general Block -->
    <div
      class="mt-5 container-answer"
      v-html="$t('ProductNowNow.answer3')"
    ></div>
      <v-btn
        rounded
        class="font-weight-light mt-3 text-capitalize btn-text"
        @click="analyticSignUp"
        color="purple darken-4"
        small
        dark
      >
        <a
          href="/signup"
          class="white--text"
          v-html="$t('ProductNowNow.button2')"
          style="font-family: Open Sans; text-decoration: none;font-size:12px;"
        ></a>
      </v-btn>

    <div
      class="mt-5 container-answer"
      v-html="$t('ProductNowNow.answer4')"
    ></div>

    <!-- Question 2-->
    <div
      class="container-question"
      v-html="$t('ProductNowNow.question2')"
    ></div>
    <div
      class="mt-3 container-answer"
      v-html="$t('ProductNowNow.answer5')"
    ></div>
        <v-btn
        rounded
        class="font-weight-light mt-3 text-capitalize btn-text"
        @click="analyticSignUp"
        color="purple darken-4"
        small
        dark
      >
        <a
          href="/signup"
          class="white--text"
          v-html="$t('ProductNowNow.button3')"
          style="font-family: Open Sans; text-decoration: none;font-size:12px;"
        ></a>
      </v-btn>
  </div>
</template>

<script>
import { analytics } from "@/config/firebaseConfig";
export default {
  methods: {
    analyticSignUp() {
      analytics.logEvent("Sig_ContPagNowNow");
    },
  },
};
</script>

<style>
.container-question {
    margin-top: 40px;
    width: 85%;
    height: 20%;
    text-align: center;
    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
  }
  .container-answer {
    margin-top: 40px;
    width: 60%;
    text-align: center;
    font-family: Open Sans;
    font-style: normal;
    font-size: 16px;
  }
    .container-mission1 {
    margin-top: 40px;
    width: 90%;
    text-align: center;
    font-family: Open Sans;
    font-weight: bold;
    font-style: italic;    
    font-size: 16px;
    }
     .container-mission2 {
    margin-top: 5px;
    width: 90%;
    text-align: center;
    font-family: Open Sans;
    font-size: 16px;
  }
@media (max-width: 500px) {
  .container-question {
    margin-top: 40px;
    width: 85%;
    height: 20%;
    text-align: center;
    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    text-decoration-color: purple darken-4;
  }
  .container-answer {
    margin-top: 40px;
    width: 90%;
    text-align: center;
    font-family: Open Sans;
    font-style: normal;
    font-size: 14px;
  }
    .container-mission1 {
    margin-top: 40px;
    width: 90%;
    text-align: center;
    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-style: italic;    
    font-size: 16px;
  }
   .container-mission2 {
    margin-top: 5px;
    width: 90%;
    text-align: center;
    font-family: Open Sans;
    font-size: 14px;
  }
}
</style>